import { apiClient } from './client';

export interface BootstrapStatusResponse {
  initialized: boolean;
  base_principal_cents?: number;
  initialized_at?: string;
}

export interface BootstrapBaseRequest {
  base_principal_cents: number;
}

export interface BootstrapBaseResponse {
  message: string;
  base_principal_cents: number;
  initialized_at: string;
}

export interface CreateInviteRequest {
  email: string;
  full_name: string;
  country: 'USA' | 'NON_USA';
  min_required_contribution_cents: number;
  locale: 'en' | 'es';
}

export interface CreateInviteResponse {
  message: string;
  invite: {
    id: string;
    email: string;
    full_name: string;
    country: string;
    code: string;
    expires_in_hours: number;
  };
}

export const adminEndpoints = {
  // Get bootstrap status
  getBootstrapStatus: () =>
    apiClient.get<BootstrapStatusResponse>('/api/admin/bootstrap_status'),

  // Bootstrap base principal
  bootstrapBase: (data: BootstrapBaseRequest) =>
    apiClient.post<BootstrapBaseResponse>('/api/admin/bootstrap_base', data),

  // Create invite
  createInvite: (data: CreateInviteRequest) =>
    apiClient.post<CreateInviteResponse>('/api/admin/invites', { invite: data }),
};
